import { c as _c } from "react/compiler-runtime";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import { twMerge } from "tailwind-merge";
import type { NavigationEntry, RouteEntry } from "@lib/navigation";
const drawerEntryClassName = twMerge("flex w-full items-center gap-6 px-4 text-lg", "dark:aria-[current=page]:text-teal-200 ");
interface DropdownProps {
  title: string;
  routes: RouteEntry[];
  Icon: React.ElementType;
}
function Dropdown(t0) {
  const $ = _c(29);
  const {
    routes,
    title,
    Icon
  } = t0;
  let t1;
  if ($[0] !== routes) {
    t1 = routes.map(_temp);
    $[0] = routes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const routePaths = t1;
  const pathname = usePathname();
  let t2;
  if ($[2] !== pathname || $[3] !== routePaths) {
    t2 = routePaths.includes(pathname ?? "");
    $[2] = pathname;
    $[3] = routePaths;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [isVisible, setIsVisible] = useState(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = function toggleVisible() {
      setIsVisible(_temp2);
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const toggleVisible = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function close() {
      setIsVisible(false);
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const close = t4;
  let t5;
  let t6;
  if ($[7] !== pathname || $[8] !== routePaths) {
    t5 = () => {
      if (!routePaths.includes(pathname ?? "")) {
        close();
      }
    };
    t6 = [pathname, routePaths];
    $[7] = pathname;
    $[8] = routePaths;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = twMerge("group/dropdown", drawerEntryClassName);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== Icon) {
    t8 = <Icon className="h-5 w-5" />;
    $[12] = Icon;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChevronDownIcon className="ml-auto h-4 w-4 self-center group-aria-expanded/dropdown:rotate-180" />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== isVisible || $[16] !== t8 || $[17] !== title) {
    t10 = <button onClick={toggleVisible} className={t7} aria-expanded={isVisible}>{t8}{title}{t9}</button>;
    $[15] = isVisible;
    $[16] = t8;
    $[17] = title;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== isVisible || $[20] !== pathname || $[21] !== routes) {
    let t12;
    if ($[23] !== isVisible || $[24] !== pathname) {
      t12 = route_0 => <Link prefetch={!route_0.disablePrefetch} aria-hidden={!isVisible} key={route_0.href} href={route_0.href} aria-current={route_0.href === pathname && "page"} className={twMerge(drawerEntryClassName, "pl-6", "aria-hidden:hidden")}><route_0.Icon />{route_0.title}</Link>;
      $[23] = isVisible;
      $[24] = pathname;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    t11 = routes.map(t12);
    $[19] = isVisible;
    $[20] = pathname;
    $[21] = routes;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[26] !== t10 || $[27] !== t11) {
    t12 = <div className="flex flex-col gap-3">{t10}{t11}</div>;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp2(prevState) {
  return !prevState;
}
function _temp(route) {
  return route.href;
}
interface DrawerEntryProps {
  item: NavigationEntry;
}
export default function DrawerEntry(t0) {
  const $ = _c(15);
  const {
    item
  } = t0;
  const pathname = usePathname();
  if ("subPages" in item) {
    let t1;
    if ($[0] !== item.Icon || $[1] !== item.subPages || $[2] !== item.title) {
      t1 = <Dropdown routes={item.subPages} title={item.title} Icon={item.Icon} />;
      $[0] = item.Icon;
      $[1] = item.subPages;
      $[2] = item.title;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  const t1 = !item.disablePrefetch;
  let t2;
  if ($[4] !== item.href || $[5] !== pathname) {
    t2 = (item.href === pathname || new RegExp(`^${item.href}/.*`).test(pathname)) && "page";
    $[4] = item.href;
    $[5] = pathname;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== item.Icon) {
    t3 = <item.Icon className="h-5 w-5" />;
    $[7] = item.Icon;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== item.href || $[10] !== item.title || $[11] !== t1 || $[12] !== t2 || $[13] !== t3) {
    t4 = <Link prefetch={t1} href={item.href} aria-current={t2} className={drawerEntryClassName}>{t3}{item.title}</Link>;
    $[9] = item.href;
    $[10] = item.title;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}